"use client";

import React from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../routes/patientRoutes/routePaths";
import "./AuthRequiredModal.css";

export default function AuthRequiredModal({ open, onClose, redirectTo = "/medicalassistant" }) {
  const navigate = useNavigate();

  const goLogin = () => {
    onClose?.();
    navigate(ROUTES.LOGIN, { state: { redirectTo } });
  };

  const goSignup = () => {
    onClose?.();
    navigate(ROUTES.SIGNUP_PATIENT, { state: { redirectTo } });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered={false}          /* ✅ désactive centered pour pouvoir contrôler la position */
      width={460}
      className="authreq-modal"
      wrapClassName="authreq-modal-wrap"
      destroyOnHidden
      zIndex={99999}            /* ✅ au-dessus du chatbot panel (qui est ~9999) */
      style={{ top: 60 }}       /* ✅ positionné en haut de l'écran, visible sur mobile */
    >
      <div className="authreq-wrap">
        <div className="authreq-icon" aria-hidden><svg width="40" height="40" viewBox="0 0 24 24" fill="none"
xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="11" width="18" height="10" rx="2" ry="2" stroke="black" stroke-width="2"/>
  <path d="M7 11V7a5 5 0 0110 0v4" stroke="black" stroke-width="2" stroke-linecap="round"/>
  <circle cx="12" cy="16" r="1.5" fill="black"/>
  <path d="M12 17.5V19" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg></div>

        <h2 className="authreq-title">Please connect</h2>
        <p className="authreq-sub">
          You need to be authenticated to access this feature.
        </p>

        <div className="authreq-actions">
          <Button
            type="primary"
            className="authreq-btn authreq-btn-login"
            onClick={goLogin}
          >
            Go to Login
          </Button>
        </div>

        <div className="authreq-divider"><span>or</span></div>

        <p className="authreq-bottom">If you don't have an account, create one.</p>

        <div className="authreq-actions">
          <Button
            className="authreq-btn authreq-btn-signup"
            onClick={goSignup}
          >
            Create account (Sign up)
          </Button>
        </div>
      </div>
    </Modal>
  );
}